<template>
    <div class="">
        <div class="">

            <form-input id="documentSet" type="number" label="Document Set" :error="msg.documentSet" v-model.trim="localCopy.documentSet"/>
            <form-input v-if="!creating" id="name" type="text" label="Name" :error="msg.name" v-model.trim="localCopy.name"/>
            <form-input v-if="!creating" id="downloadCount" type="text" label="Downloads" :modelValue="localCopy.downloadCount" readonly="true"/>
            <form-div v-if="localCopy.documentId" label="File">
              <custom-button v-if="localCopy.documentId" class="w-full -mt-2" type="primary" @click="download">Download</custom-button>
            </form-div>
            <!-- <form-input v-if="!creating" id="filename" type="text" label="Filename" :error="msg.filename" v-model.trim="localCopy.filename">
                <custom-button v-if="localCopy.documentId" class="w-12" type="white" @click="download">
                    <DownloadIcon class="mt-1 h-5 w-5 text-gray-600"/>
                </custom-button>

            </form-input> -->

            <form-file-input class="" id="docname" type="file" label="Replace File" accept="application/pdf" :error="msg.newFile" v-model="newFile"/>



            <div v-if="!creating && (changed || newFile)" class="flex gap-2 pt-8">
                <custom-button class="flex-grow" type="primary" @click="save">Save</custom-button>
                <custom-button class="flex-grow" type="white" @click="close">Cancel</custom-button>
            </div>

            <div v-if="creating" class="flex gap-2 pt-8">
                <custom-button class="flex-grow" type="primary" @click="create">Create</custom-button>
            </div>

        </div>
    </div>
</template>

<script>
import FormInput from '../../components/FormInput.vue'
import FormDiv from '../../components/FormDiv.vue'
import FormFileInput from '../../components/FormFileInput.vue'
import CustomButton from '../../components/CustomButton.vue'
import FormData from 'form-data'
import DownloadFile from '../../DownloadFile.js'
import _ from 'lodash';

export default {
    components: { FormInput, CustomButton, FormFileInput, FormDiv },
    props: [
        'dataId', 'path', 'creating'
    ],
    data: function() {
      return {
          changed: false,
          setPassword: false,
          newFile: null,
          backingData: {},
          localCopy: {},
          msg: {},
      }
    },
    mounted: async function() {
        if (this.creating) {
            this.backingData = {}
            this.localCopy = {}
        }
        else {
          await this.updateData()
        }
    },
    methods: {
      updateData: async function() {
        let query = await this.axios.get(this.path + `/${this.dataId}`) 
        this.backingData = query.data
        this.localCopy = Object.assign(Object.create(Object.getPrototypeOf(this.backingData)), this.backingData)
        this.changed = false
      },
      close: function(navToId) {
        this.$emit('close', navToId)
      },
      validate: function() {
        this.msg = {}

        var constraints = {
            name: {
                presence: true,
                length: { minimum: 2}
            },
            filename: {
                presence: true,
                length: { minimum: 2}
            }
        };

        this.msg = this.$validate(this.localCopy, constraints) || {}
        if (this.creating) {
            if (!this.msg.password && this.localCopy.password != this.localCopy.password2) { this.msg.password2 = 'Passwords must match' }
        }

        return Object.keys(this.msg).length == 0
      },
      create: async function() {
        if (!this.newFile) {
            this.msg.newFile = 'File must be uploaded'
            return
        }

        let file = await this.uploadFile()
        let payload = {
            documentSet: this.localCopy.documentSet,
            filename: file.filename,
            name: file.filename.replace('.pdf', ''),
            documentId: file.id
        }

        let id = await this.axios.post(this.path + '/create', payload)

        this.$emit('detailUpdated', this.localCopy)
        this.close(id.data)
      },
      uploadFile: async function() {
        let data = new FormData();
        data.append('data', this.newFile, this.newFile.name);
        data.append('deviceModelId', this.localCopy.id)
        data.append('name', this.newFile.name)
        let ret = await this.axios.post(this.path + '/upload_document', data, {
            headers: {
                'Content-Type': `multipart/form-data`,
            }
        })
        return { id: ret.data.id, filename: this.newFile.name}
      },
      download: async function() {
        let query = await this.axios.get(this.path + '/get_download_link/' + this.localCopy.documentId)
        const url = query.data
        DownloadFile(document, this.localCopy.filename, url)
      },
      save: async function() {
        if (this.validate()) {
            try {
                if (this.newFile) {
                    let file = await this.uploadFile()
                    this.localCopy.filename = file.filename
                    this.localCopy.name = file.filename.replace('.pdf', '')
                    this.localCopy.documentId = file.id
                }

                await this.axios.post(this.path + '/update', this.localCopy)
                this.$emit('detailUpdated', this.localCopy)

                this.updateData()
                this.newFile = null
            }
            catch (error) {
                if (error && error.response && error.response.data && error.response.data.msg) {
                    this.msg = error.response.data.msg
                }
            }
        }
      },      
    },
    updated: function() {
      if (!this.creating) {
        const newVal = !_.isEqual(this.localCopy, this.backingData)
        if (this.changed != newVal) {
            this.changed = newVal;
            this.$emit('detailDirty', newVal)
        }
      }
    }
}
</script>